import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PassiveTouchendDirective, PassiveTouchstartDirective } from './passive-touch.directive';

@NgModule({
    declarations: [PassiveTouchstartDirective, PassiveTouchendDirective],
    imports: [CommonModule],
    exports: [PassiveTouchstartDirective, PassiveTouchendDirective],
    providers: [PassiveTouchstartDirective, PassiveTouchendDirective]
})
export class PassiveTouchModule { }
